import Vue from 'vue'
import VueRouter from 'vue-router'

import Catalog from '../components/Catalog'
import CatalogMainPage from '../components/CatalogMainPage'

import NotFound404 from '../components/NotFound404'

import CatalogListPage from '../components/CatalogListPageApi'
import CatalogItemDetailPage from '../components/CatalogItemDetailPage'

import ResponsiblePersonRegister from '../components/ResponsiblePersonRegister'
import OrganizationRegister from '../components/OrganizationRegister'

import AnalyticsDetail from '../components/AnalyticsDetail'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

let router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'root',
            component: CatalogMainPage,
            meta: {
                'title': 'Каталог системи Трембіта'
            }
        },
        {
            path: '/register/responsible-application',
            name: 'responsible-application',
            component: ResponsiblePersonRegister,
            meta: {
                'title': 'Реєстрація | Відповідальна особа'
            }
        },
        {
            path: '/register/organization-application',
            name: 'organization-application',
            component: OrganizationRegister,
            meta: {
                'title': 'Реєстрація | Повідомлення-приєднання'
            }
        },
        // {
        //     path: '/register',
        //     name: 'register',
        //     redirect: { name: 'responsible-application' },
        //     // component: Catalog,
        //     children: [
        //         {
        //             path: '/register/responsible-application',
        //             name: 'responsible-application',
        //             component: ResponsiblePersonRegister,
        //             meta: {
        //                 'title': 'Реєстрація | Відповідальна особа'
        //             }
        //         },
        //     ]
        // },
        {
            path: '/catalog',
            name: 'catalog',
            redirect: { name: 'organizations-list' },
            component: Catalog,
            children: [
                {
                    path: '/catalog/organizations',
                    name: 'organizations-list',
                    component: CatalogListPage,
                    meta: {
                        'title': 'Каталог | Організації'
                    }
                    // props: true
                },
                {
                    path: '/catalog/information_resources',
                    name: 'information-resources-list',
                    component: CatalogListPage,
                    meta: {
                        'title': 'Каталог | Е-ресурси'
                    }
                    // props: true
                },
                {
                    path: '/catalog/subsystems',
                    name: 'subsystems-list',
                    component: CatalogListPage,
                    meta: {
                        'title': 'Каталог | Підсистеми'
                    }
                    // props: true
                },
                {
                    path: '/catalog/interfaces',
                    name: 'interfaces-list',
                    component: CatalogListPage,
                    meta: {
                        'title': 'Каталог | Інтерфейси е-ресурсів'
                    }
                    // props: true
                },
                {
                    path: '/catalog/services',
                    name: 'services-list',
                    component: CatalogListPage,
                    meta: {
                        'title': 'Каталог | Сервіси'
                    }
                    // props: true
                },
                {
                    path: '/catalog/interactions',
                    name: 'interactions-list',
                    component: CatalogListPage,
                    meta: {
                        'title': 'Каталог | Взаємодії'
                    }
                    // props: true
                },
                {
                    path: '/catalog/servers',
                    name: 'servers-list',
                    component: CatalogListPage,
                    meta: {
                        'title': 'Каталог | Шлюзи безпечного обміну'
                    }
                    // props: true
                },



                {
                    path: '/catalog/organizations/:id',
                    name: 'organization-detail-info',
                    component: CatalogItemDetailPage,
                    meta: {
                        'title': 'Каталог | Про організацію'
                    }
                    // props: true
                },
                {
                    path: '/catalog/information_resources/:id',
                    name: 'information-resource-detail-info',
                    component: CatalogItemDetailPage,
                    meta: {
                        'title': 'Каталог | Про е-ресурс'
                    }
                    // props: true
                },
                {
                    path: '/catalog/subsystems/:id',
                    name: 'subsystem-detail-info',
                    component: CatalogItemDetailPage,
                    meta: {
                        'title': 'Каталог | Про підсистему'
                    }
                    // props: true
                },
                {
                    path: '/catalog/interfaces/:id',
                    name: 'interface-detail-info',
                    component: CatalogItemDetailPage,
                    meta: {
                        'title': 'Каталог | Про інтерфейс е-ресурсу'
                    }
                    // props: true
                },
                {
                    path: '/catalog/services/:id',
                    name: 'service-detail-info',
                    component: CatalogItemDetailPage,
                    meta: {
                        'title': 'Каталог | Про сервіс'
                    }
                    // props: true
                },
                {
                    path: '/catalog/interactions/:id',
                    name: 'interaction-detail-info',
                    component: CatalogItemDetailPage,
                    meta: {
                        'title': 'Каталог | Про взаємодію'
                    }
                    // props: true
                },
                {
                    path: '/catalog/servers/:id',
                    name: 'server-detail-info',
                    component: CatalogItemDetailPage,
                    meta: {
                        'title': 'Каталог | Про шлюз безпечного обміну'
                    }
                    // props: true
                },

                {
                    path: '/catalog/organizations/analytics/:id',
                    name: 'organization-analytics-info',
                    component: AnalyticsDetail,
                    meta: {
                        'title': 'Каталог | Про організацію | Про організацію'
                    }
                    // props: true
                },
            ]
        },
        // {
        //     path: '/stats',
        //     name: 'stats',
        //     component: StatsPage,
        //     // props: true
        // },
        // {
        //     path: '/cabinet',
        //     name: 'cabinet',
        //     component: CabinetPage,
        //     // props: true
        // },
        // {
        //     path: '/exchanges-graph',
        //     name: 'exchanges-graph',
        //     component: ExchangesGraphPage,
        //     // props: true
        // },
        {
            path: '/not-found',
            name: 'notFound',
            component: NotFound404
        },
        {
            path: '*',
            name: '404',
            component: NotFound404
        }
    ]
}); 

export default router;